(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["byroersen-google-reviews-api"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('.byr-google-reviews');

    const escapeHtml = (value) => {
      const node = document.createElement('div');
      node.textContent = value == null ? '' : String(value);
      return node.innerHTML;
    };

    const starString = (rating) => {
      const rounded = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
      return '★'.repeat(rounded) + '☆'.repeat(5 - rounded);
    };

    const loadGoogleMaps = (apiKey) => {
      if (window.google && window.google.maps && window.google.maps.importLibrary) {
        return Promise.resolve();
      }

      if (window.byrGoogleMapsPromise) {
        return window.byrGoogleMapsPromise;
      }

      window.byrGoogleMapsPromise = new Promise((resolve, reject) => {
        const callback = `byrGoogleReady${Date.now()}`;
        window[callback] = () => {
          delete window[callback];
          resolve();
        };

        const script = document.createElement('script');
        script.async = true;
        script.defer = true;
        script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&loading=async&libraries=places&language=nl&region=NL&callback=${callback}`;
        script.onerror = () => reject(new Error('Google Maps kon niet worden geladen'));
        document.head.appendChild(script);
      });

      return window.byrGoogleMapsPromise;
    };

    const reviewCard = (review, mapUrl) => {
      const author = review.authorAttribution && review.authorAttribution.displayName
        ? review.authorAttribution.displayName
        : 'Google gebruiker';
      const date = review.relativePublishTimeDescription || '';
      const text = review.text || '';
      const rating = Number(review.rating) || 0;

      return `
        <article class="byr-google-review">
          <div class="byr-google-review__top">
            <span class="byr-google-review__avatar" aria-hidden="true">${escapeHtml(author.trim().charAt(0).toUpperCase())}</span>
            <div>
              <h3>${escapeHtml(author)}</h3>
              <p>${escapeHtml(date)}</p>
            </div>
          </div>
          <div class="byr-google-review__stars" aria-label="${escapeHtml(rating)} van 5 sterren">${starString(rating)}</div>
          <blockquote>${escapeHtml(text)}</blockquote>
          <a href="${escapeHtml(mapUrl)}" target="_blank" rel="noopener noreferrer">Bekijk op Google</a>
        </article>
      `;
    };

    roots.forEach(async (root) => {
      const apiKey = root.dataset.apiKey;
      const placeId = root.dataset.placeId;
      const maxReviews = Number(root.dataset.maxReviews) || 3;
      const status = root.querySelector('[data-review-status]');

      if (!apiKey || !placeId) {
        status.textContent = 'Getoonde reviews zijn handmatig gecontroleerd';
        return;
      }

      try {
        await loadGoogleMaps(apiKey);
        const { Place } = await google.maps.importLibrary('places');
        const place = new Place({ id: placeId, requestedLanguage: 'nl' });
        await place.fetchFields({ fields: ['displayName', 'rating', 'userRatingCount', 'reviews', 'googleMapsURI'] });

        const reviews = Array.isArray(place.reviews)
          ? place.reviews.filter((review) => review.text).slice(0, maxReviews)
          : [];
        const mapUrl = place.googleMapsURI || root.querySelector('.byr-google-reviews__button').href;

        if (place.rating != null) {
          root.querySelector('.byr-google-reviews__rating').textContent = Number(place.rating).toFixed(1).replace('.', ',');
        }

        if (place.userRatingCount != null) {
          root.querySelector('.byr-google-reviews__count').textContent = String(place.userRatingCount);
        }

        if (reviews.length) {
          root.querySelector('[data-review-grid]').innerHTML = reviews.map((review) => reviewCard(review, mapUrl)).join('');
        }

        root.querySelectorAll('.byr-google-reviews__button').forEach((link) => {
          link.href = mapUrl;
        });
        status.textContent = 'Actueel opgehaald via Google Places';
      } catch (error) {
        status.textContent = 'Getoonde reviews zijn handmatig gecontroleerd';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
